// extracted by mini-css-extract-plugin
export var credit = "CreditList-module--credit--ee9b2";
export var creditTitle = "CreditList-module--creditTitle--ca4f0";
export var cyan = "CreditList-module--cyan--7fca2";
export var description = "CreditList-module--description--671a0";
export var icon = "CreditList-module--icon--e5700";
export var red = "CreditList-module--red--16758";
export var root = "CreditList-module--root--0e1dc";